/* eslint-disable */
export default {
  noRecords: '最近の記録が見つかりません。',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
